
export const RQ_GET_ALL_PRODUCT_API = {
  url: 'api/product/lookup/all/active',
  method: 'GET',
  auth: false,
};
//show all product also inactive product
export const RQ_GET_PRODUCT_API = {
  url: 'api/product/lookup/all',
  method: 'GET',
  auth: false,
};

export const RQ_PRODUCTS_BY_IDS_API = {
  url: 'api/product/lookup/byids',
  method: 'POST',
  auth: false,
};

export const RQ_PUT_PRODUCT_API = {
  url: 'api/product/register',
  method: 'POST',
  auth: true,
};

export const RQ_PUT_UPDATE_PRODUCT_API = {
  url: 'api/product/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
};

export const RQ_PRODUCTS_BY_FILTER_API = {
  url: 'api/product/lookup/byfilter',
  method: 'POST',
  auth: false,
  Search:false,
};

export const RQ_TRENDING_PRODUCTS__API = {
  url: 'api/product/trending',
  method: 'GET',
  auth: false,
};

export const RQ_NEW_ARRIVALS_PRODUCTS__API = {
  url: 'api/product/new-arrivals',
  method: 'GET',
  auth: false,
};

export const RQ_PRODUCT_IMAGE_UPLOAD_API = {
  url: 'api/uploads/presigned',
  method: 'POST',
  auth: true,
};

export const RQ_DELETE_PRODUCT_API = {
  url: 'api/product/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};  
